import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, onSnapshot, deleteDoc, doc, query, orderBy } from "firebase/firestore";
import AdminPortfolioForm from "./AdminPortfolioForm";
import { toAbsoluteUrl } from "../utils/url";

function AdminPortfolioManager() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);

  useEffect(() => {
    const q = query(collection(db, "projects"), orderBy("createdAt", "desc"));
    const unsub = onSnapshot(q, (snap) => {
      const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setItems(rows);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const startAdd = () => {
    setEditItem(null);
    setShowForm(true);
  };

  const startEdit = (row) => {
    setEditItem(row);
    setShowForm(true);
  };

  const onSaved = () => {
    setShowForm(false);
    setEditItem(null);
  };

  const onCancel = () => {
    setShowForm(false);
    setEditItem(null);
  };

  const onDelete = async (id) => {
    if (!window.confirm("Delete this project?")) return;
    await deleteDoc(doc(db, "projects", id));
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-base font-extrabold text-gray-900">Projects</h3>
        <button
          onClick={startAdd}
          className="text-xs sm:text-sm font-semibold bg-[#211033] text-white border border-teal-700 rounded-full py-1.5 px-4 hover:bg-white hover:text-[#211033] ease-in duration-300 shadow"
        >
          Add New Project
        </button>
      </div>

      {showForm && (
        <div className="rounded-lg border border-gray-200 bg-white p-4">
          <AdminPortfolioForm
            docId={editItem?.id || null}
            initial={editItem || null}
            onSaved={onSaved}
            onCancel={onCancel}
          />
        </div>
      )}

      <div className="rounded-lg border border-gray-200 bg-white">
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-50 text-gray-600">
              <tr>
                <th className="text-left px-4 py-2">Title</th>
                <th className="text-left px-4 py-2">Live Link</th>
                <th className="text-left px-4 py-2">GitHub</th>
                <th className="text-left px-4 py-2">Tags</th>
                <th className="text-left px-4 py-2">Tech</th>
                <th className="text-left px-4 py-2">Created</th>
                <th className="text-right px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={6} className="px-4 py-6 text-center text-gray-500">Loading...</td>
                </tr>
              ) : items.length === 0 ? (
                <tr>
                  <td colSpan={6} className="px-4 py-6 text-center text-gray-500">No projects yet.</td>
                </tr>
              ) : (
                items.map((row) => (
                  <tr key={row.id} className="border-t border-gray-100 hover:bg-gray-50/60">
                    <td className="px-4 py-2 font-semibold text-gray-900">{row.title}</td>
                    <td className="px-4 py-2 text-teal-700 underline"><a href={toAbsoluteUrl(row.liveLink)} target="_blank" rel="noreferrer">Open</a></td>
                    <td className="px-4 py-2">{row.githubLink ? (<a href={row.githubLink} target="_blank" rel="noreferrer" className="text-teal-700 underline">Repo</a>) : <span className="text-gray-400">—</span>}</td>
                    <td className="px-4 py-2 text-gray-700 truncate max-w-[240px]">{(row.tags || []).join(", ")}</td>
                    <td className="px-4 py-2 text-gray-700 truncate max-w-[240px]">{(row.tech || []).join(", ")}</td>
                    <td className="px-4 py-2 text-gray-600">{row.createdAt?.toDate ? row.createdAt.toDate().toLocaleDateString() : "—"}</td>
                    <td className="px-4 py-2 text-right">
                      <div className="inline-flex items-center gap-2">
                        <button onClick={() => startEdit(row)} className="text-xs font-semibold text-[#211033] bg-gray-100 border border-gray-200 rounded-full px-3 py-1 hover:bg-white">Edit</button>
                        <button onClick={() => onDelete(row.id)} className="text-xs font-semibold text-white bg-red-500 border border-red-600 rounded-full px-3 py-1 hover:bg-red-600">Delete</button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AdminPortfolioManager;
